import type { FC } from 'react';
import { Grid2, Box } from '@mui/material';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import HomeImage from '/public/images/home/homeSeven.svg';

const Introduction: FC = () => {
  const t = useTranslations('Home');
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Grid2
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'stretched', sm: 'center' }}
      justifyContent={'center'}
      spacing={4}
      container
    >
      <Grid2 size={12} container data-aos={isMd ? 'fade-right' : 'fade-up'}>
        <Grid2
          size={{
            xs: 12,
            md: 8,
          }}
          sx={{
            fontWeight: 700,
            fontSize: {
              xs: '36px',
              md: '48px',
            },
          }}
        >
          {t('workdayTitle')}
        </Grid2>
      </Grid2>
      <Grid2 size={12} container>
        <Grid2
          data-aos={isMd ? 'fade-right' : 'fade-up'}
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <Box py={2}>
            <Typography
              sx={{ fontWeight: 400 }}
              align="left"
              color={'text.secondary'}
            >
              {t('workdayDescription')}
            </Typography>
          </Box>
          <Box py={2}>
            <Typography variant="h5" sx={{ fontWeight: 700 }} align="left">
              {t('complianceTitle')}
            </Typography>
            <Typography
              sx={{ fontWeight: 400 }}
              align="left"
              color={'text.secondary'}
              pt={1}
            >
              {t('complianceDescription')}
            </Typography>
          </Box>
          <Box py={2}>
            <Typography variant="h5" sx={{ fontWeight: 700 }} align="left">
              {t('pricingTitle')}
            </Typography>
            <Typography
              sx={{ fontWeight: 400 }}
              align="left"
              color={'text.secondary'}
              pt={1}
            >
              {t('pricingDescription')}
            </Typography>
          </Box>
          <Box py={2}>
            <Typography variant="h5" sx={{ fontWeight: 700 }} align="left">
              {t('customerTitle')}
            </Typography>
            <Typography
              sx={{ fontWeight: 400 }}
              align="left"
              color={'text.secondary'}
              pt={1}
            >
              {t('customerDescription')}
            </Typography>
          </Box>
        </Grid2>
        <Grid2
          data-aos={isMd ? 'fade-left' : 'fade-up'}
          size={{
            xs: 12,
            sm: 6,
          }}
          sx={{ flexGrow: 1 }}
          display={{
            xs: 'none',
            md: 'block',
          }}
        >
          <Image
            src={HomeImage}
            alt="sailglobalHome"
            width={500}
            // height={480}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
            }}
          />
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default Introduction;
